import React from "react";
import styles from "./Loading.module.scss";

export default function Loading() {
    return (
        <div className={styles.loadingcontainer}>
            <div className={styles.spinner}></div>
            <img src="/assets/images/fcd-logo.png" className={styles.loadinglogo} />
        </div>
    );
}
